import { createSlice } from "@reduxjs/toolkit"
import { authApiService } from "../../Apis/Auth"
import { adminApiService } from "../../Apis/Admin"
import { userApiService } from "../../Apis/User"

const getStoredSelectedNeighborhood = () => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const storedValue = localStorage.getItem('selectedNeighborhood')
    return storedValue ? JSON.parse(storedValue) : null
  } catch (error) {
    return null
  }
}

let initialState = {
  isLoggedIn: false,
  token: null,
  user: null,
  selectedNeighborhood: getStoredSelectedNeighborhood(),
  availableNeighborhoods: []
}

export const AuthSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    logout: (state) => {
      state.isLoggedIn = false
      state.token = null
      state.user = null
      state.selectedNeighborhood = null
      state.availableNeighborhoods = []
      localStorage.removeItem('selectedNeighborhood')
    },
    setSelectedNeighborhood: (state, action) => {
      state.selectedNeighborhood = action.payload
      localStorage.setItem('selectedNeighborhood', JSON.stringify(action.payload))
    },
    setAvailableNeighborhoods: (state, action) => {
      state.availableNeighborhoods = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApiService.endpoints.login.matchFulfilled, (state, action) => {
      let { success, token, data } = action.payload
      const storedNeighborhood = getStoredSelectedNeighborhood()
      if (success) {
        state.isLoggedIn = success
        state.token = token
        state.user = data

        // Set up neighborhoods for admin
        if (data.role === 'super_admin') {
          // Super admin - set default or first assigned neighborhood
          state.availableNeighborhoods = data.assignedNeighborhoods || []
          state.selectedNeighborhood = data.defaultNeighborhood || storedNeighborhood || data.assignedNeighborhoods?.[0] || null
        } else if (data.role === 'neighborhood_admin') {
          // Neighborhood admin - use their default or first assigned
          state.availableNeighborhoods = data.assignedNeighborhoods || []
          state.selectedNeighborhood = data.defaultNeighborhood || storedNeighborhood || data.assignedNeighborhoods?.[0] || null
        }

        // Save selected neighborhood to localStorage
        if (state.selectedNeighborhood) {
          localStorage.setItem('selectedNeighborhood', JSON.stringify(state.selectedNeighborhood))
        }
      } else {
        state.isLoggedIn = false
        state.token = null
        state.user = null
      }
    })
    builder.addMatcher(userApiService.endpoints.updateUser.matchFulfilled, (state, action) => {
      let { success, data } = action.payload

      if (success && state.user._id === data._id) {
        state.user = data
      }

    })
    builder.addMatcher(adminApiService.endpoints.changePassword.matchFulfilled, (state, action) => {
      let { success, data } = action.payload

      if (success && state.user?._id === data?._id) {
        state.user = data
      }
    })
  }
})

export const { logout, setSelectedNeighborhood, setAvailableNeighborhoods } = AuthSlice.actions
export default AuthSlice.reducer
